import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum TicketStatus {
  Open = 1,
  Pedent = 2,
  InAttendance = 3,
  Resolved = 4,
  Completed = 5,
  Closed = 6,
}
EnumDescriptions.setDescriptions(TicketStatus, [
  i18n.t('enums.open'),
  i18n.t('enums.pedent'),
  i18n.t('enums.in_attendance'),
  i18n.t('enums.resolved'),
  i18n.t('enums.completed'),
  i18n.t('enums.closed'),
]);
